import React from "react";


const LoadingBox = () => {
    return (
        <div>   <i className="fa fa-spinner fa-spin"></i> Loading...
        </div>
    )
}

export default LoadingBox